function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "80",
  viewBox: "0 0 64 80",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: "32",
  cy: "32",
  r: "27"
})), /*#__PURE__*/React.createElement("g", {
  id: "Meldedialog",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Meldung-1a",
  transform: "translate(-152 -243)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(152 243)"
}, /*#__PURE__*/React.createElement("g", {
  id: "pina"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.522 49.917C62.004 44.92 64 38.437 64 32 64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 6.211 1.402 12.42 4.832 17.917C7.12 53.582 16.175 63.61 32 80c15.36-16.723 24.2-26.75 26.522-30.083z",
  id: "Oval",
  fill: "#FABE28",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval-2",
  fill: "#FFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})))))));